'use strict';

angular.module('amexReconciliationApp')
  .component('advancedSearchSavedSearches', {
    templateUrl: 'scripts/views/components/advanced-search-saved-searches.html',
    bindings: {
      searches: '<',
      onSelect: '&',
      onDelete: '&'
    },
    controller: function () {
      var self = this;
      var confirming = null;

      self.selectSearch = function (search) {
        self.onSelect({search: search});
      };

      self.displayDelete = function (search) {
        return !_.isEqual(search.name, confirming);
      };
      
      self.deleteSavedSearch = function (search) {
        self.onDelete({search: search});
      };
      
      self.deleteCanceled = function () {
        confirming = null;
      };

      self.confirmingDelete = function(search) {
        confirming = search.name;
      };
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/advancedSearchSavedSearches.js
// module id = 433
// module chunks = 0